import { https , httpsFile } from './http.js';

export function index () {
    return https().get('material-group1');
}
export function getMatGrp1 (search,offset) {
    return https().get(`getMatGrp1?search=${search}&offset=${offset}`);
}